export const KEY_DEFINITIONS = "check_definitions";
export const KEY_TASKS = "check_tasks";